export const manifest = {
  screens: {
    scr_entejy: { name: "Home", route: "/" },
  },
}
